import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import WaitlistSmsModalLegacy from './waitlist-sms-modal-legacy'

import type { WaitlistSmsModalProps } from './waitlist-sms-modal.types'

const WaitlistSmsModalDS = dynamic(
  () => import(/* webpackChunkName: "waitlist-sms-modal-ds" */ '@src/components/blocks/waitlist-sms-modal-ds'),
)

const WaitlistSmsModal = (props: WaitlistSmsModalProps) => {
  if (shouldUseDesignSystem()) {
    return <WaitlistSmsModalDS {...props} />
  }

  return <WaitlistSmsModalLegacy {...props} />
}

export type { WaitlistSmsModalProps } from './waitlist-sms-modal.types'
export default WaitlistSmsModal
